import Logger from "~/services/logger/logger";

export class ApiUtils {
  // /{([a-zA-Z_$][a-zA-Z0-9_$]*)}/g
  private static _javascriptVariablePattern = "[a-zA-Z_$][a-zA-Z_$0-9]*";
  // Extract all params enclosed in curly braces in a path. E.g.: /api/v3/{foo}/{bar}
  private static _pathParamRegex = new RegExp(
    `\\{(${this._javascriptVariablePattern})\\}`,
    "g"
  );

  static interpolateParams(
    urlTemplate: string,
    params: Record<string, string | number | boolean>
  ): string {
    try {
      return urlTemplate.replace(this._pathParamRegex, (match, key) => {
        const value = params[key];
        return value !== void 0 ? encodeURIComponent(value) : match;
      });
    } catch (e) {
      Logger.instance.warn("ApiUtils: couldn't interpolate params", e);
    }

    return urlTemplate;
  }
}
